module.exports = __webpack_public_path__ + "static/media/logo-white.a7ee3035.svg";